var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_2328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41561 2.58789C4.73562 2.58789 1.75562 5.57456 1.75562 9.25456C1.75562 12.9346 4.73562 15.9212 8.41561 15.9212C12.1023 15.9212 15.0889 12.9346 15.0889 9.25456C15.0889 5.57456 12.1023 2.58789 8.41561 2.58789ZM8.42228 14.5879C5.47562 14.5879 3.08895 12.2012 3.08895 9.25456C3.08895 6.30789 5.47562 3.92122 8.42228 3.92122C11.3689 3.92122 13.7556 6.30789 13.7556 9.25456C13.7556 12.2012 11.3689 14.5879 8.42228 14.5879ZM8.27561 5.92122H8.23562C7.96895 5.92122 7.75561 6.13456 7.75561 6.40122V9.54789C7.75561 9.78122 7.87561 10.0012 8.08228 10.1212L10.8489 11.7812C11.0756 11.9146 11.3689 11.8479 11.5023 11.6212C11.6423 11.3946 11.5689 11.0946 11.3356 10.9612L8.75561 9.42789V6.40122C8.75561 6.13456 8.54228 5.92122 8.27561 5.92122Z",
    fill: "#3A4B68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_2328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.422363 0.750977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/AccessTime.6a35250a98fd386216f0b05d593997b1.svg";
export { ForwardRef as ReactComponent };